export default "/static/assets/marketing_lead_output.5ceb29bdfc2c20f1b30eb1643b9086a1.png";